import React from 'react';

const UnlockSection = () => (
  <section className="py-5 px-4 bg-light text-dark">
    <div className="container">
      <div className="col-12 col-md-11 col-lg-10">
          <h2 className="mb-4 fs-2 fw-semibold text-start">
            Unlock Your Business Potential with Nurturix.
          </h2>

          <p className="mb-3 fs-5 text-start">
            We empower businesses to thrive by taking the hassle out of lead generation, CRM management, and bookkeeping.
            Our dedicated team works behind the scenes to ensure a steady flow of qualified leads while managing your
            customer relationships and financial records with precision.
          </p>

          <p className="mb-4 fs-5 text-start">
            Imagine focusing on what you do best — growing your business — while we handle the essential background work.
            With our user-friendly platform, you can easily create accounts and manage everything with just a few simple clicks.
          </p>

          <p className="mb-4 fs-5 text-start">
            Our comprehensive services include:
          </p>
          <ul className="list-unstyled fs-5 ps-3 text-start">
            <li className="mb-2">• <strong>Lead Generation:</strong> We connect you with potential clients who are ready to engage.</li>
            <li className="mb-2">• <strong>CRM Management:</strong> We streamline your customer interactions, ensuring no opportunity slips through the cracks.</li>
            <li className="mb-2">• <strong>Bookkeeping:</strong> We keep your financials organized and up-to-date, giving you peace of mind.</li>
            <li className="mb-2">• <strong>Ad Marketing:</strong> Our targeted marketing strategies help you reach your ideal audience effectively.</li>
          </ul>

          <div className="mt-4 pt-3 border-top text-start">
            <p className="mb-3 fs-5">
              Let us take care of the details so you can concentrate on your core mission.
              Partner with Nurturix and watch your business flourish!
            </p>
            <p className="mb-0 fs-5">
              Contact us today to get started on your journey to effortless growth!
            </p>
          </div>
      </div>
    </div>
  </section>
);

export default UnlockSection;
